const Air = () => {
  return <div>Air</div>;
};

export default Air;
